import { twMerge } from 'tailwind-merge';
import { SpinIcon, CircleLoaderIcon } from 'mode-shared/components/icons';

export const Spinner = ({ className, size = 48 }: { className?: string; size?: number }) => {
  return <SpinIcon className={twMerge('mx-auto text-primary', className)} size={size} />;
};

export const CircleLoader = ({ className, size = 24 }: { className?: string; size?: number }) => {
  return <CircleLoaderIcon className={twMerge('animate-spin mx-auto text-primary', className)} size={size} />;
};
